
<div>
  <slot></slot>
  <p v-if="!hasARelationOfCorrectType">Please create a relationship to configure this field</p>
</div>
